import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EmptyBlock = ({ media }) => {
    return (
        <div className="snake-block media-block empty-block-pulse" style={{ cursor: 'default' }}>
            <div style={{
                border: '2px dashed #555',
                borderRadius: 10,
                height: 145,
                width: 90,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
                marginBottom: 10,
            }}>
                <FontAwesomeIcon
                    icon={['fas', media === 'MEDIA' ? 'film' : 'user']}
                    size="2x"
                    color="#555"
                />
                <span style={{ color: '#555', fontSize: 11, textAlign: 'center', padding: '0 6px' }}>
                    Search below
                </span>
            </div>
            <h3 className="media-title" style={{ color: '#555' }}>???</h3>
        </div>
    );
};

export default EmptyBlock;
